import React from 'react'
import ReceiveOrderQueue from './ReceiveOrderQueue'

const ReceiveOrders = () => {
  return (
    <div><ReceiveOrderQueue/></div>
  )
}

export default ReceiveOrders